module.exports = "https://cdn.hellotech.com/client-assets/security_cameras_desktop_3860bd228fb284b2f36648b2f2658212.png";